import GoogleMap from "../utils/map";
import Form from "../modules/form";

const Contacts = {
  init() {
    new Form(".form.cform");
    Contacts.renderMap();
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },
};

export default Contacts;
